export default "__VITE_ASSET__dJk6PCUT__"